import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";

import { Settings, Wallpaper, SaveAs } from "@mui/icons-material";
import {
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
import { MuiColorInput } from "mui-color-input";

import Switch from "@mui/material/Switch";

import { AppContext } from "../../../contexts/App.Context";
import "../../../screens/SuperScreen/SuperScreen.css";
import Drawer from "../Drawer";
import {
  isVideoOrImage,
  postMessageToSuperScreen,
} from "../../../utils/utility";
import { Lock, LockOpen } from "@mui/icons-material";
import MoveableWindow from "./MoveableWindow";
import "./FixedSuperScreen.css";
import validDataUrl from "valid-data-url";
export default function FixedSuperScreen({
  children,
  eventId,
  onQuoteSettingsClick,
  isSocketConnected,
  quoteCardSettings,
  setQuoteCardSettings,
}) {
  const appContext = useContext(AppContext);
  const [backgroundColor, setBackgroundColor] = useState("rgba(0, 0, 0, 0)");
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [backgroundFile, setBackgroundFile] = useState(null);
  const [overlayFile, setOverlayFile] = useState(null);
  const [settingDialogOpen, setSettingDialogOpen] = useState(false);
  const [overlayImage, setOverlayImage] = useState(null);
  const [isSwitchOn, setIsSwitchOn] = useState(false);

  const [boundingRect, setBoundingRect] = useState(null);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [isEditEnabled, setIsEditEnabled] = useState(false);
  const movableRef = useRef(null);

  onbeforeunload = (event) => {
    if (backgroundImage || overlayImage || backgroundColor !== "black") {
      event.preventDefault();
    }
  };

  const listenMessage = (event) => {
    if (event.data) {
      if (
        event.data.screenSettings !== undefined &&
        event.data.screenSettings !== null
      ) {
        if (event.data.screenSettings?.quoteCardSettings) {
          setQuoteCardSettings(event.data.screenSettings.quoteCardSettings);
        }
        if (event.data.screenSettings?.boundingRect) {
          setBoundingRect(event.data.screenSettings.boundingRect);
        }
        if (event.data.screenSettings?.windowWidth) {
          setWindowSize({
            width: event.data.screenSettings.windowWidth,
            height: event.data.screenSettings.windowHeight,
          });
        }
        if (event.data.screenSettings?.backgroundImage) {
          setBackgroundImage(event.data.screenSettings.backgroundImage);
        }
        if (event.data.screenSettings?.overlayImage) {
          setOverlayImage(event.data.screenSettings.overlayImage);
        }
        if (event.data.screenSettings?.backgroundColor) {
          setBackgroundColor(event.data.screenSettings.backgroundColor);
        }
        if (event.data.screenSettings?.enableOverlay) {
          setIsSwitchOn(event.data.screenSettings.enableOverlay);
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("message", listenMessage);
    window.addEventListener("beforeunload", onbeforeunload);
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler once to set initial size
    handleResize();

    return () => {
      window.removeEventListener("beforeunload", onbeforeunload);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("message", listenMessage);
    };
  }, []);
  const handleMouseMove = useCallback(() => {
    document.body.style.cursor = "default";
    clearTimeout(handleMouseMove.timer);
    handleMouseMove.timer = setTimeout(function () {
      document.body.style.cursor = "none";
    }, 2000);
  }, []);
  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      clearTimeout(handleMouseMove.timer);
      document.body.style.cursor = "default";
    };
  }, [handleMouseMove]);

  const handleOverlayImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setOverlayFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setOverlayImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveOverlayImage = (event) => {
    setOverlayImage(null);
    setOverlayFile("");
  };

  const handleSwitchChange = (event) => {
    setIsSwitchOn(event.target.checked);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setBackgroundFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        console.log("reader.result", reader.result);
        setBackgroundImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setBackgroundImage(null);
    setBackgroundFile("");
  };

  const changeBackgroundColor = (newColor) => {
    const element = document.getElementById("superScreenPortal");
    if (element) {
      element.style.backgroundColor = newColor;
    }
  };

  const handleColorChange = (newColor) => {
    changeBackgroundColor(newColor);
    setBackgroundColor(newColor);
  };
  const onSave = async () => {
    const boundingRectData = movableRef.current.getBoundingClientRect();
    const transform = movableRef.current?.style.transform;
    const payload = {
      boundingRect: boundingRectData,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      enableOverlay: isSwitchOn,
      transform,
      quoteCardSettings,
    };
    if (backgroundColor) {
      payload["backgroundColor"] = backgroundColor;
    }
    if (backgroundFile || backgroundFile === "") {
      payload["backgroundImage"] = backgroundFile;
    }
    if (overlayFile || overlayFile === "") {
      payload["overlayImage"] = overlayFile;
    }
    if (quoteCardSettings.backgroundImage) {
      if (!validDataUrl(quoteCardSettings.backgroundImage)) {
        delete payload.quoteCardSettings.backgroundImage;
      }
    } else {
      payload.quoteCardSettings.backgroundImage = "";
    }

    postMessageToSuperScreen({
      screenSettings: payload,
      _id: window.name,
    });
    appContext.triggerToast(true, {
      type: "success",
      message: "Layout saved successfully.",
    });
  };

  const Connecting = () => {
    return <div className="ssConnecting">Connecting to Console...</div>;
  };

  return (
    <>
      <div style={{ backgroundColor }} className="ssSuperScreenPortal">
        <Dialog
          open={settingDialogOpen}
          onClose={() => setSettingDialogOpen(false)}
        >
          <DialogTitle>Settings</DialogTitle>
          <DialogContent className="ssDialogContent">
            <MuiColorInput
              value={backgroundColor}
              onChange={handleColorChange}
            />

            <div style={{ cursor: "pointer" }}>
              <label htmlFor="overlay-image">Overlay:</label>
              <input
                type="file"
                id="overlay-image"
                onChange={handleOverlayImageChange}
                accept="image/*, video/*"
                style={{ display: "none" }}
              />
              <label htmlFor="overlay-image" style={{ cursor: "pointer" }}>
                <IconButton
                  component="span"
                  color="primary"
                  aria-label="upload"
                  size="large"
                >
                  <Wallpaper />
                </IconButton>
                Upload Overlay Image/Video
              </label>
            </div>
            {overlayImage && (
              <>
                {overlayImage.startsWith("data:image") ||
                isVideoOrImage(overlayImage) === "image" ? (
                  <img
                    className="ssOverlayImageSetting"
                    src={overlayImage}
                    alt="Overlay Preview"
                  />
                ) : (
                  <video
                    className="ssOverlayImageSetting"
                    style={{ objectFit: "contain" }}
                    src={overlayImage}
                    autoPlay
                    loop
                    muted
                  />
                )}
                <Button variant="outlined" onClick={handleRemoveOverlayImage}>
                  Remove Overlay Image/Video
                </Button>
              </>
            )}
            <div style={{ cursor: "pointer" }}>
              <label htmlFor="background-image">Background:</label>
              <input
                type="file"
                id="background-image"
                onChange={handleImageChange}
                accept="image/*, video/*"
                style={{ display: "none" }}
              />
              <label htmlFor="background-image" style={{ cursor: "pointer" }}>
                <IconButton
                  component="span"
                  color="primary"
                  aria-label="upload"
                  size="large"
                >
                  <Wallpaper />
                </IconButton>
                Upload Background Image/Video
              </label>
            </div>
            {backgroundImage && (
              <>
                {backgroundImage.startsWith("data:image") ||
                isVideoOrImage(backgroundImage) === "image" ? (
                  <img
                    className="ssBackgroundImageSetting"
                    src={backgroundImage}
                    alt="Background Preview"
                  />
                ) : (
                  <video
                    className="ssBackgroundImageSetting"
                    style={{ objectFit: "contain" }}
                    src={backgroundImage}
                    autoPlay
                    loop
                    muted
                  />
                )}
                <Button variant="outlined" onClick={handleRemoveImage}>
                  Remove Background Image/Video
                </Button>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSettingDialogOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        {backgroundImage &&
          (backgroundImage.startsWith("data:image") ||
          isVideoOrImage(backgroundImage) === "image" ? (
            <img
              className="ssOverlayImage"
              style={{ zIndex: 0 }}
              src={backgroundImage}
              alt="Overlay"
            />
          ) : (
            <video
              className="ssOverlayImage"
              style={{ objectFit: "contain", zIndex: 0 }}
              src={backgroundImage}
              autoPlay
              loop
              muted
            />
          ))}

        {overlayImage &&
          (overlayImage.startsWith("data:image") ||
          isVideoOrImage(overlayImage) === "image" ? (
            <img className="ssOverlayImage" src={overlayImage} alt="Overlay" />
          ) : (
            <video
              className="ssOverlayImage"
              style={{ objectFit: "contain" }}
              src={overlayImage}
              autoPlay
              loop
              muted
            />
          ))}

        <MoveableWindow
          isEditEnabled={isEditEnabled}
          ref={movableRef}
          isSwitchOn={isSwitchOn}
          boundingRect={boundingRect}
          windowSize={windowSize}
        >
          {isSocketConnected ? children || null : <Connecting />}
        </MoveableWindow>
      </div>
      <Drawer open={false}>
        <div className="ssControlIconsContainer">
          <Box>
            <Switch
              checked={isSwitchOn}
              onChange={handleSwitchChange}
              color="default"
              title="Enable Overlay"
            />
            Enable Overlay
          </Box>

          <Button
            variant="outlined"
            startIcon={<Settings />}
            onClick={() => setSettingDialogOpen(true)}
            fullWidth={true}
            sx={{ mt: 2 }}
          >
            Settings
          </Button>
          <Button
            variant="outlined"
            startIcon={<Settings />}
            onClick={onQuoteSettingsClick}
            fullWidth={true}
            sx={{ mt: 2 }}
          >
            Quote Card Settings
          </Button>

          <Button
            variant="outlined"
            startIcon={<SaveAs />}
            onClick={onSave}
            fullWidth={true}
            sx={{ mt: 2 }}
          >
            Save Layout
          </Button>

          {/* Lock Icon */}
          {isEditEnabled ? (
            <IconButton
              onClick={() => setIsEditEnabled((pre) => !pre)}
              size="large"
              title="Disable Drag and Resize"
              sx={{ mt: 2 }}
            >
              <Lock fontSize="48" />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => setIsEditEnabled((pre) => !pre)}
              size="large"
              title="Enable Drag and Resize"
              sx={{ mt: 2 }}
            >
              <LockOpen fontSize="48" />
            </IconButton>
          )}

          {/* End: Lock icon */}
        </div>
      </Drawer>
    </>
  );
}
